<div
	class="print-bols-dialog"
	role="dialog"
	aria-labelledby="printBolsTitle"
>
	<h2 id="printBolsTitle">Print Bills of Lading</h2>
	<div style="padding: 0 0 1rem 0; margin-bottom: 1rem; border-bottom: 1px solid #e5e7eb;">
		<p-checkbox
			[binary]="true"
			label="Select All"
			[ngModel]="areAllSelected()"
			(onChange)="toggleAll($event.checked)"
		></p-checkbox>
	</div>
	<div class="groups-list">
		<div
			*ngFor="let group of groupedEvents"
			class="group-section"
		>
			<div class="group-header">
				<p-checkbox
					[binary]="true"
					(onChange)="toggleGroup(group, $event.checked)"
					label="{{ group.group }}"
					[ngModel]="isGroupSelected(group)"
				></p-checkbox>
			</div>
			<div class="events-list">
				<div
					*ngFor="let event of group.events"
					class="event-item"
				>
					<p-checkbox
						[(ngModel)]="event.selected"
						[binary]="true"
						label="{{ event?.startTime }} - {{ event?.customer?.name || 'Unknown' }} ({{ event?.event?.job?.code || 'Unknown' }})"
					></p-checkbox>
				</div>
			</div>
		</div>
	</div>
	<div
		class="dialog-footer"
		style="flex-direction: column; align-items: stretch; gap: 1rem;"
	>
		<div *ngIf="loading">
			<div
				style="display: flex; justify-content: space-between; margin-bottom: 0.5rem; font-size: 0.875rem; color: #4b5563;">
				<span>{{ status }}</span>
				<span>{{ progress }}%</span>
			</div>
			<p-progressBar
				[value]="progress"
				[showValue]="false"
				styleClass="h-1rem"
			></p-progressBar>
		</div>
		<div style="display: flex; justify-content: flex-end; gap: 0.5rem;">
			<p-button
				*ngIf="!loading"
				label="Cancel"
				styleClass="p-button-text"
				(onClick)="ref.close()"
			></p-button>
			<p-button
				label="Print Selected"
				(onClick)="print()"
				[loading]="loading"
				icon="pi pi-print"
			></p-button>
		</div>
	</div>
</div>